import { Select } from 'antd';
import { ComponentPropsWithRef } from 'react';

import { QueryProps } from './types';
import { useQuerySelectItemComponent } from './useQuerySelectItemComponent';

interface Props extends ComponentPropsWithRef<typeof Select>, QueryProps {
  labelKey?: string;
}

export function QuerySelectItem({
  disabled,
  placeholder,
  query,
  queryKey,
  ref,
  labelKey,
  value,
  valueKey,
  onChange,
  ...rest
}: Props) {
  const {
    models: { isLoading, options },
  } = useQuerySelectItemComponent({ query, queryKey, valueKey, labelKey });
  return (
    <Select
      showSearch
      loading={isLoading}
      options={options}
      optionFilterProp={labelKey ? 'label' : undefined}
      disabled={disabled}
      placeholder={placeholder}
      ref={ref}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
}
